class ApiConfig {
  static getEntryPoint() {
    return process.env.REACT_APP_API_URL || `${window.location.origin}/api/`;
  }
}

export default ApiConfig;
